import { render, staticRenderFns } from "./addBlind.vue?vue&type=template&id=0b427bbc&scoped=true&"
import script from "./addBlind.vue?vue&type=script&lang=js&"
export * from "./addBlind.vue?vue&type=script&lang=js&"
import style0 from "./addBlind.vue?vue&type=style&index=0&id=0b427bbc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b427bbc",
  null
  
)

export default component.exports